module.exports = __webpack_public_path__ + "static/media/editblue.a37fef2d.svg";